import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import createLogger from 'vuex/dist/logger'
import { sync } from 'vuex-router-sync'
import Interface from './modules/Interface'
import Settings from './modules/Settings'
import Blog from './modules/Blog'
import Route from './modules/Route'
import router from '@/router'
const isNotProd = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const createStore = () => {
  createLogger('creating store')
  const store = new Vuex.Store({
    plugins: [pathify.plugin]
      .concat(isNotProd ? [createLogger()] : []),
    modules: {
      Interface,
      Settings,
      Blog,
      Route
    }
  })

  store._actions['Route/unsync'] = sync(store, router, { moduleName: 'Route' })
  return store
}

export default createStore
